import z from 'zod';
const postgresIntMax = 2_147_483_647;
const nonblankString = z.string().refine((value) => value.trim().length > 0, {
    message: 'String must contain a non-whitespace character',
});
const nullableDocumentHeaderSchema = z.strictObject({
    esn: nonblankString.nullable(),
    engineType: nonblankString.nullable(),
    tsn: z.number().finite().nonnegative().nullable(),
    csn: z.number().int().finite().nonnegative().max(postgresIntMax).nullable(),
    asOfDate: z.iso.date().nullable(),
});
export const documentHeaderReadyWebhookSchema = z
    .strictObject({
    type: z.literal('document-header-ready'),
    projectId: z.string().min(1),
    documentId: z.string().min(1),
    generation: z.number().int().positive().max(postgresIntMax),
    snapshotHash: z.string().regex(/^[a-f0-9]{64}$/),
    generatedAt: z.iso.datetime(),
    pageIds: z.array(z.string().min(1)),
    sourcePageId: z.string().min(1).nullable(),
    sourceCategory: z.enum(['adStatus', 'llpStatus', 'qecList', 'arc']).nullable(),
    header: nullableDocumentHeaderSchema,
})
    .superRefine((snapshot, context) => {
    const hasHeaderEvidence = Object.values(snapshot.header).some((value) => value !== null);
    const hasSourcePage = snapshot.sourcePageId !== null;
    const hasSourceCategory = snapshot.sourceCategory !== null;
    if (snapshot.pageIds.length === 0 && hasHeaderEvidence) {
        context.addIssue({
            code: 'custom',
            message: 'A document with no active pages cannot carry header evidence',
            path: ['pageIds'],
        });
    }
    if ((hasHeaderEvidence && (!hasSourcePage || !hasSourceCategory)) ||
        (!hasHeaderEvidence && (hasSourcePage || hasSourceCategory))) {
        context.addIssue({
            code: 'custom',
            message: 'Header evidence requires source page and category; retractions require both null',
            path: ['sourcePageId'],
        });
    }
    if (snapshot.sourcePageId !== null && !snapshot.pageIds.includes(snapshot.sourcePageId)) {
        context.addIssue({
            code: 'custom',
            message: 'Source page must belong to snapshot page membership',
            path: ['sourcePageId'],
        });
    }
});
//# sourceMappingURL=document-header-ready.webhook.js.map